<template>
  <div :class="source">
    <form class="information-form" @submit.prevent="handleSubmit" v-if="data.content &&data.content.length">
      <div class="declare" v-if="data.note">{{ data.note }}</div>
      <div class="form-container">
        <div class="form-content">
        <div class="form-content-item" v-for="(item, index) in data.content" :key="item.id">
          <!-- 输入类型 -->
          <div class="item-input" v-if="getInputType(item)">
            <label :class="['label', { 'required': item.required }]">{{ item.name }}</label>
            <van-field :type="getInputType(item)" rows="1" :maxlength="item.type === 2 ? 1000 : 100"
            autosize  @blur="checkFormItem(item, index)"
              v-model="item.value" clearable :placeholder="'请输入' + item.name" class="input" />
          </div>
          <!-- 非输入类型 -->
          <div class="item-input" v-else>
            <label :class="['label', { 'required': item.required }]">{{ item.name }}</label>
            <van-field readonly clickable v-model="item.text" @click="widgetClick(item, index)" clearable
              :placeholder="'请选择'+item.name" right-icon="arrow-down" class="input" />
          </div>
          <div class="error" v-if="item.error">{{ item.error }}</div>
        </div>
      </div>
    </div>
      <div class="form-footer">
        <div class="form-agree" v-if="data.hasAgreement">
        <span @click="switchAgreement" :class="['agree-input',{'agreed':data.isAgree}]"></span>
        <div class="agree-detail">
          <template v-for="item in data.agreement">
            <a class="agree-href" v-if="item.link" :href="item.link">{{ item.text }}</a>
            <span class="agree-text" v-else>{{ item.text }}</span>
          </template>
        </div>
      </div>
        <div class="footer-btns">
          <div class="button skip" @click="handleSkip" v-if="data.isSkip">跳过</div>
        <div :class='["button", "submit", { "fit-width": !data.isSkip }]' @click="handleSubmit">提交</div>
        </div>
      </div>
    </form>
    <!-- 有多个日期选择器时，共用同一个 -->
    <date-time-picker-for-h5 ref="datePicker" @pickedDateTimeChange="pickedDateTimeChange"></date-time-picker-for-h5>
    <!-- 多选弹层 -->
    <MultipleSelectForH5 ref="multipleSelector" @multipleSelectChange="multipleSelectChange"></MultipleSelectForH5>
    <!-- 单选弹层 -->
    <single-select-for-h5 ref="singleSelector" @singleSelectChange="singleSelectChange"></single-select-for-h5>
  </div>
</template>

<script>
import Popup from '@/components/Popup';
import DateTimePickerForH5 from '@/components/FormWidget/DateTimePickerForH5';
import { formatDateToString } from '@/utils/date';
import MultipleSelectForH5 from '@/components/FormWidget/MultipleSelectForH5';
import SingleSelectForH5 from '@/components/FormWidget/SingleSelectForH5.vue';
import 'vant/lib/field/style';
import MixinInformationForm from './MixinInformationForm';
// 表单控件对应type映射，来源参考自定义字段
// https://iwiki.woa.com/pages/viewpage.action?pageId=4008547837
const formWidgetTypeMap = {
  0: 'unknown', // 未知
  1: 'text',  // 单行文本
  2: 'textarea', // 多行文本
  3: 'number', // 数字
  4: 'date', // 日期
  5: 'time', // 时间，
  6: 'select', // 单选
  7: 'radio', // 单选框
  8: 'checkbox', // 多选框
  9: 'casecad',  // 级联
};
// 输入框类型的表单控件
const inputTypeList = [formWidgetTypeMap[1], formWidgetTypeMap[2], formWidgetTypeMap[3]];
export default {
  mixins: [MixinInformationForm],
  components: {
    Popup,
    DateTimePickerForH5,
    MultipleSelectForH5,
    SingleSelectForH5,
  },
  data() {
    return {
      isShowDatePicker: false,
    };
  },
  methods: {
    /**
     * 展开日期选择器
     */
    showDatePicker(idx) {
      this.$refs.datePicker.show(idx);
    },
    /**
     * 选择日期
     * @param {*} val
     */
    pickedDateTimeChange(data) {
      const { val, pickerIdx } = data;
      if (pickerIdx > -1) {
        const date = formatDateToString(val);
        this.data.content[pickerIdx].value = date;
        this.$set(this.data.content[pickerIdx], 'text', date);
      }
    },
    // 获取输入框类型
    getInputType(item) {
      const { type } = item;
      if (inputTypeList.includes(formWidgetTypeMap[type])) {
        return formWidgetTypeMap[type] || 'text';
      }
      return '';
    },
    /**
     * 非输入类控件点击 日期/单选/多选等
     * @param {*} item
     */
    widgetClick(item = {}, index) {
      const { type } = item;
      const widgetType = formWidgetTypeMap[type] || formWidgetTypeMap[0];
      switch (widgetType) {
        // 日期选择
        case formWidgetTypeMap[4]:
          this.showDatePicker(index);
          break;
        // 多选
        case formWidgetTypeMap[8]:
          this.$refs.multipleSelector.show({
            options: item.options,
            widgetSymbol: index,
          });
          break;
        // 单选
        case formWidgetTypeMap[6]:
        case formWidgetTypeMap[7]:
          this.$refs.singleSelector.show({
            options: item.options,
            widgetSymbol: index,
          });
      }
    },
    /**
     * 多选值更新
     */
    multipleSelectChange(data) {
      const { choosed = [], widgetSymbol } = data;
      const value = [];
      const text = [];
      choosed.forEach((item) => {
        value.push(item.value);
        text.push(item.text);
      });
      if (widgetSymbol > -1) {
        this.data.content[widgetSymbol].value = value;
        this.$set(this.data.content[widgetSymbol], 'text', text);
      }
    },
    /**
     * 单选
     * @param {*} data
     */
    singleSelectChange(data) {
      const { choosed = {}, widgetSymbol } = data;
      if (widgetSymbol > -1) {
        this.data.content[widgetSymbol].value = choosed.value;
        this.$set(this.data.content[widgetSymbol], 'text', choosed.text);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.information-form {
  padding: 0 16px;
  .declare {
    font-size: 14px;
    line-height: 20px;
    padding-bottom: 12px;
    color: rgba(1,11,50,0.41);
  }
  .form-content {
    .form-content-item {
      .item {
        &-input {
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          border-bottom: 1px solid rgba(80, 110, 155, 0.08);
          padding: 10px 0;
          .input {
            flex: 1;
            padding-top: 0;
            padding-bottom: 0;
          }
          .label {
            font-size: 16px;
            color: rgba(0,1,10,0.93);
            width: 80px;
          }
        }

      }

      .error {
        color: #F75559;
        font-size: 12px;
        line-height: 16px;
        margin-top: 8px;
      }
    }
  }

  .form-agree {
    padding-top: 8px;
    display: flex;
    align-items: center;
    .agree-input {
      width: 16px;
      height: 16px;
      border-radius: 3px;
      border: 1px solid rgba(17, 32, 70, 0.13);
      background:  #FFF;
      margin-right: 8px;
      box-sizing: border-box;
    }
    .agree-text {
      font-size: 16px;
      line-height: 24px;
      color: rgba(1, 11, 50, 0.41);
    }
    .agree-detail {
      flex: 1;
    }

    .agree-href {
      color: #4A70FF;
      font-size: 16px;
    }
    .agreed {
      background: url(./assets/checkbox.svg);
      border: none;
    }
  }

  .required::after {
    content: '*';
    color: #F75559;
    font-size: 14px;
    display: inline-block;
    width: 16px;
    box-sizing: border-box;
  }

  .form-footer {
    position: fixed;
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px 20px;
    background: #FFFFFF;
    bottom: 0;
    left: 0;
    .button {
      flex: 1;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      box-sizing: border-box;
      border-radius: 3px;
      text-align: center;
    }

    .submit {
      background: @primary;
      color: #FFFFFF;
    }

    .skip {
      border: 1px solid rgba(17, 32, 70, 0.13);
      background: #FFFFFF;
      margin-right: 8px;
    }
    .footer-btns {
      margin-top: 8px;
      display: flex;
    }
  }

  .menu {
    position: relative;
  }
}
.page {
  .declare {
    color:  rgba(1, 11, 50, 0.41);
    font-size: 14px;
    line-height: 20px;
  }
}
.input {
  :deep(.van-field__body){
    font-size: 16px !important;
  }
}

</style>

